import { createContext } from 'react';
var SearchStyle;
(function (SearchStyle) {
    /** Search results will appear in a dropdown below the search bar. */
    SearchStyle["dropdown"] = "dropdown";
    /** Search results will appear in a search results page. */
    SearchStyle["resultsPage"] = "resultsPage";
})(SearchStyle || (SearchStyle = {}));
// The default {} will never be used as we wrap the App component with this.
export const Context = createContext({});
export { SearchStyle };
//# sourceMappingURL=Config.js.map